export const CURRENT_BILLING_SUBSCRIPTION_STATUSES = [
    'active',
    'trialing',
    'past_due',
    'unpaid',
    'incomplete',
    'paused',
] as const;

export const BILLING_SUBSCRIPTION_QUERY_STATUSES = [
    ...CURRENT_BILLING_SUBSCRIPTION_STATUSES,
    'canceled',
] as const;

const currentBillingSubscriptionStatusSet = new Set<string>(
    CURRENT_BILLING_SUBSCRIPTION_STATUSES,
);

export function isCurrentBillingSubscriptionStatus(
    value: unknown,
): value is typeof CURRENT_BILLING_SUBSCRIPTION_STATUSES[number] {
    return typeof value === 'string'
        && currentBillingSubscriptionStatusSet.has(value.trim());
}

export function isCanceledBillingSubscriptionStatus(value: unknown): value is 'canceled' {
    return typeof value === 'string' && value.trim() === 'canceled';
}

export function selectCurrentBillingSubscription<T extends { status: string }>(
    subscriptions: T[],
): T | null {
    return subscriptions.find((subscription) =>
        isCurrentBillingSubscriptionStatus(subscription.status)
    ) ?? null;
}

export function selectLatestCanceledSubscription<T extends { status: string }>(
    subscriptions: T[],
): T | null {
    return subscriptions.find((subscription) =>
        isCanceledBillingSubscriptionStatus(subscription.status)
    ) ?? null;
}
